import { createFileRoute } from "@tanstack/react-router"
import { BackofficeCompanyDetail } from "modules/backoffice/components/companies/BackofficeCompanyDetail"

export const Route = createFileRoute(
  "/_base/_auth/backoffice/organizations/$id/companies/$companyId/",
)({
  component: BackofficeCompanyDetail,
})
